import { render, staticRenderFns } from "./PagoVistaAdministrador.vue?vue&type=template&id=2b5ceeb8&"
import script from "./PagoVistaAdministrador.vue?vue&type=script&lang=js&"
export * from "./PagoVistaAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./PagoVistaAdministrador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
